module.exports = __webpack_public_path__ + "media/images/homes-bf88aa865d2047517bb9448b6b9ff55a.png";